import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IWorkOrder } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getWorkOrderUUID = createUUID();

export const useWorkOrder = (id: string | null) => {
  const stateManager = useComponentState();

  const [workOrder, setWorkOrder] = useState<IWorkOrder | null>(null);

  const getWorkOrder = () => {
    stateManager.abort(getWorkOrderUUID);
    return stateManager.run(async () => {
      if (!id) {
        return null;
      }

      const response = await taskService.workOrders.getById({ id });

      if (response.status === HTTP_STATUSES.OK) {
        setWorkOrder(response.data);
      }

      return response;
    });
  };

  return {
    workOrder,
    getWorkOrder,
    isLoading: stateManager.isBusy(),
  };
};
